import { support as allSupportStrings } from '../strings'
import { hasDOM } from '../utilities/dom'

const INTERNIC = 'internic.ca'
const REBELCOM = 'rebel.com'
const REBELCA = 'rebel.ca'

const getResellerFromHost = () => {
  if (hasDOM) {
    const host = window.location.hostname

    if (host.includes('internic')) {
      return INTERNIC
    }

    if (host.includes('.ca')) {
      return REBELCA
    }
  }

  return REBELCOM
}

const RESELLER = process.env.GATSBY_RESELLER || getResellerFromHost()

const GET_RESELLER_ID = () => {
  switch (RESELLER) {
    case 'internic.ca':
      return 4
    case 'rebel.ca':
      return 3
    default:
      return 2
  }
}

const RESELLER_ID = GET_RESELLER_ID()

const isRebel = RESELLER === 'rebel.ca' || RESELLER === 'rebel.com'
const isRebelCA = RESELLER === 'rebel.ca'
const isRebelCOM = RESELLER === 'rebel.com'
const isInternic = RESELLER === 'internic.ca'
const resellerName = RESELLER.charAt(0).toUpperCase() + RESELLER.slice(1)
const resellerTitle = resellerName.split('.')[0]

const { rebel: rebelSupport, internic: internicSupport } = allSupportStrings
const SUPPORT_STRINGS = isInternic ? internicSupport : rebelSupport

const getServerResellerMapping = () => {
  if (isInternic) {
    return 'Internic'
  }
  if (isRebelCA) {
    return 'DAC'
  }
  return 'Rebel'
}

const SERVER_RESELLER = getServerResellerMapping()

const socialLinksRebel = [
  {
    icon: 'twitter',
    href: 'https://twitter.com/rebeldotcom',
    title: `Rebel's Twitter account`,
    ml: '-0.9rem',
  },
  {
    icon: 'facebook',
    href: 'https://www.facebook.com/rebeldotcomhosting/',
    title: `Rebel's Facebook account`,
  },
  {
    icon: 'instagram',
    href: 'https://instagram.com/rebeldotcom/',
    title: `Rebel's Instagram account`,
    ml: '-0.9rem',
  },
  {
    icon: 'youtube',
    href: 'https://www.youtube.com/channel/UCn8PAsNxo2zC8Ka53Feg_-Q',
    title: `Rebel's YouTube account`,
  },
  {
    icon: 'linkedin',
    href: 'https://ca.linkedin.com/company/rebel-com',
    title: `Rebel's LinkedIn account`,
  },
]

const socialLinksInternic = [
  {
    icon: 'twitter',
    href: 'https://twitter.com/internicdotca',
    title: `Internic Twitter`,
  },
  {
    icon: 'facebook',
    href: 'https://www.facebook.com/Internic.ca',
    title: `Internic Facebook`,
  },
]

const socialLinks = isRebel ? socialLinksRebel : socialLinksInternic

export {
  INTERNIC,
  REBELCA,
  REBELCOM,
  RESELLER,
  RESELLER_ID,
  isRebel,
  isRebelCA,
  isRebelCOM,
  isInternic,
  resellerName,
  resellerTitle,
  SUPPORT_STRINGS,
  SERVER_RESELLER,
  socialLinks,
}
